module.exports = __webpack_public_path__ + "img/container2Logo2.10c34635.png";